import React from 'react';
import { Avatar } from '@mui/material';
import { useStorageImageSrc } from '../../hooks/useStorageImageSrc';

/** Avatar that tries /storage/ and /api/storage/ URLs when images fail to load. */
const StorageAvatar = ({ storagePath, alt, children, sx, ...rest }) => {
  const { src, onError } = useStorageImageSrc(storagePath);

  return (
    <Avatar
      src={src}
      alt={alt}
      imgProps={{ onError }}
      sx={sx}
      {...rest}
    >
      {children}
    </Avatar>
  );
};

export default StorageAvatar;
